import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ParentalControlsHeader } from '../../shared/ParentalControlHeader/ParentalControlsHeader';
import { PinInputs } from '../../shared/PinInputs/PinInputs';
import { Button } from '../../../Button/Button';

import type { FC } from 'react';

import * as styles from './ConfirmCode.module.scss';

interface ConfirmCodeProps {
  code?: string;
  handleClose: () => void;
  handleValidate: () => void;
}

const ConfirmCode: FC<ConfirmCodeProps> = ({
  code,
  handleClose,
  handleValidate,
}) => {
  const [isActivationCodeCorrect, setIsActivationCodeCorrect] = useState(false);

  const { t } = useTranslation();
  return (
    <>
      <ParentalControlsHeader
        titleText={t('confirm your code')}
        subtitleText={t('repeat the code')}
      />
      <PinInputs
        codeToValidate={code}
        checkPinCorrection={setIsActivationCodeCorrect}
      />
      <Button
        variant="contained"
        size="medium"
        active={isActivationCodeCorrect}
        className={styles.button}
        disabled={!isActivationCodeCorrect}
        onClick={handleValidate}
      >
        {t('confirm and save')}
      </Button>
      <Button
        variant="contained"
        size="medium"
        className={styles.button}
        onClick={handleClose}
      >
        {t('cancel')}
      </Button>
    </>
  );
};

export { ConfirmCode };
